import { render, staticRenderFns } from "./bathUpdate.vue?vue&type=template&id=18421255"
import script from "./bathUpdate.vue?vue&type=script&lang=js"
export * from "./bathUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports